import React from "react";
import Navbar from "../components/Navbar";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaCloudSun, FaHome, FaLightbulb, FaTools } from "react-icons/fa";

const OutdoorFloods = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#542757] to-[#9b1f6c] text-white">
      <Navbar />

      {/* Header Section */}
      <div className="max-w-6xl mx-auto px-6 py-16 mt-10">
        <motion.h1
          className="text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-yellow-400 mb-8 drop-shadow-lg"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Outdoor & Flood Lighting
        </motion.h1>

        <motion.p
          className="text-white/80 text-lg text-center mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          Enhance safety, highlight architecture, and create a welcoming ambiance with durable and
          efficient outdoor lighting solutions.
        </motion.p>

        {/* Feature Grid */}
        <div className="grid md:grid-cols-2 gap-10">
          {/* Tip 1 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaCloudSun className="text-yellow-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">1. Weatherproof Lighting</h2>
            <p className="text-white/80">
              Choose IP65 or higher-rated fixtures to ensure protection from rain, dust, and
              temperature changes — perfect for long-lasting outdoor performance.
            </p>
          </motion.div>

          {/* Tip 2 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaHome className="text-pink-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">2. Accent Your Exterior</h2>
            <p className="text-white/80">
              Highlight your building’s features, garden, or pathways with directional floodlights and
              landscape lighting to create an inviting atmosphere.
            </p>
          </motion.div>

          {/* Tip 3 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaLightbulb className="text-yellow-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">3. Energy-Efficient Illumination</h2>
            <p className="text-white/80">
              Upgrade to LED floodlights — they deliver powerful brightness while consuming less
              electricity and producing minimal heat.
            </p>
          </motion.div>

          {/* Tip 4 */}
          <motion.div
            className="bg-white/10 rounded-2xl shadow-md p-6 hover:shadow-lg transition"
            whileHover={{ scale: 1.02 }}
          >
            <FaTools className="text-purple-400 text-4xl mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">4. Easy Installation & Maintenance</h2>
            <p className="text-white/80">
              HLC’s outdoor fixtures are designed for simple setup and minimal upkeep — ensuring your
              lighting remains reliable year-round.
            </p>
          </motion.div>
        </div>

        {/* Call to Action */}
        <motion.div
          className="mt-16 text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <h3 className="text-2xl font-semibold text-white mb-3">
            Brighten Your Outdoors with HLC
          </h3>
          <p className="text-white/80 mb-6">
            Explore our range of flood and outdoor lighting solutions — designed for performance,
            style, and energy savings.
          </p>
          {/* Filters the shop to Street And Flood Light Series, reusing the
              existing filtering system */}
          <button
            type="button"
            onClick={() => navigate("/shop", { state: { category: "STREET AND FLOOD LIGHT SERIES" } })}
            className="inline-block bg-gradient-to-r from-pink-500 to-yellow-400 text-white font-medium px-6 py-3 rounded-full shadow-md hover:shadow-lg transition"
          >
            Explore Outdoor Lights
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default OutdoorFloods;
